var React = require('react');

function CircleArrowDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Component 1"},React.createElement("path",{"id":"Vector","d":"M12.0003 12.9503L16.9503 8.00032L18.3643 9.41432L12.0003 15.7783L5.63626 9.41432L7.05026 8.00032L12.0003 12.9503Z","fill":"#0A2240"})));
}

CircleArrowDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CircleArrowDown;

CircleArrowDown.default = CircleArrowDown;
